export default __webpack_public_path__ + "static/media/send_approval.e2351403.svg";